/**
 * @description
 *
 * Получает только цифры из строки
 *
 * @param {string} value - входная строка
 * @param {object} options - конфиг
 * @param { Function } options.returnType - тип возвращаемого значения
 *
 * return {string | void}
 */

function getOnlyNumbers(value, { returnType = String } = {}) {
  if (typeof value !== 'string') {
    return
  }

  return returnType(value.replace(/[^0-9]/g, ''))
}

export default getOnlyNumbers
